<mat-card>
  <mat-chip-list selectable="false" *ngIf="notifications$ | async as notifications">
    <mat-chip *ngFor="let notification of notifications" [color]="notification.color" selected>
      {{ notification.content }}</mat-chip>
  </mat-chip-list>
</mat-card>
